require('./helpers/bundle-manifest').register(JSON.parse("{\"5ZPII\":\"index.e2a7a47b.js\",\"lp5u4\":\"sprite.0513d8a2.svg\"}"));